/** How the library draws the same cases: as pictures, or as a list of columns. */
export enum CaseDisplay {
  Grid = 'grid',
  List = 'list',
}
